var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostsList',{attrs:{"resource":_vm.resource,"columns":_vm.headers,"title":"Склады вне Украины","add-route":{ name: 'warehouses-post' },"store":"warehousesPosts","path":"warehouses"}})}
var staticRenderFns = []

export { render, staticRenderFns }